// extracted by mini-css-extract-plugin
export var downArrow = "_ai-0";
export var label = "_ai-1";
export var treatmentCard = "_ai-3";
export var upArrow = "_ai-2";